import { useAppTheme } from '@shared-ui/theme'
import Svg, { Path } from 'react-native-svg'

type Props = {
  size?: number
  color?: string
}

export function AppIconCalendarCheck({ size = 16, color }: Props) {
  const theme = useAppTheme()
  const fill = color ?? theme.COLOR_TEXT_PRIMARY

  return (
    <Svg width={size} height={size} viewBox="0 0 16 16" fill="none">
      <Path
        fill={fill}
        d="M13.4377 10.2168C13.6861 9.90631 14.1389 9.85595 14.4494 10.1043C14.7599 10.3527 14.8103 10.8055 14.5619 11.116L11.8955 14.4496C11.7676 14.6095 11.5773 14.707 11.3729 14.7184C11.1686 14.7296 10.9692 14.6536 10.8244 14.509L9.49082 13.1754C9.20969 12.8943 9.20977 12.4386 9.49082 12.1574C9.772 11.8762 10.2276 11.8762 10.5088 12.1574L11.2729 12.9215L13.4377 10.2168ZM12.6135 4.66602C12.6133 4.32748 12.3387 4.05288 12.0002 4.05273H4.0002C3.66155 4.05273 3.38705 4.3274 3.38691 4.66602V5.2793H12.6135V4.66602ZM14.0533 7.99961C14.0533 8.39725 13.7307 8.71992 13.333 8.71992C12.9355 8.71978 12.6135 8.39717 12.6135 7.99961V6.71992H3.38691V11.9996C3.38691 12.3384 3.66145 12.6129 4.0002 12.6129H7.33301C7.73065 12.6129 8.05332 12.9356 8.05332 13.3332C8.05318 13.7307 7.73057 14.0527 7.33301 14.0527H4.0002C2.86618 14.0527 1.94629 13.1337 1.94629 11.9996V4.66602C1.94643 3.53211 2.86626 2.61289 4.0002 2.61289H4.61348V1.99961C4.61348 1.60205 4.93548 1.27944 5.33301 1.2793C5.73065 1.2793 6.05332 1.60196 6.05332 1.99961V2.61289H9.94629V1.99961C9.94629 1.60196 10.269 1.2793 10.6666 1.2793C11.0642 1.2793 11.3869 1.60196 11.3869 1.99961V2.61289H12.0002C13.134 2.61303 14.0532 3.5322 14.0533 4.66602V7.99961Z"
      />
    </Svg>
  )
}
